import { Routes , Route } from 'react-router-dom';
import Layout from '../Layout/Layout';
import Inicio from '../../pages/Inicio/Inicio';
import Biografia from '../../pages/Biografia/Biografia';
import Contacto from '../../pages/Contacto/Contacto';
import Servicios from '../../pages/Servicios/Servicios';
import Testimonios from '../../pages/Testimonios/Testimonios'

const Allroutes = () => {
  return (
    <Routes>
        <Route path='/' element = {<Layout/>}>
            <Route path='/' element = {<Inicio/>}/>
            <Route path='/biografia' element = {<Biografia/>}/>
            <Route path='/contacto' element = {<Contacto/>}/>
            <Route path='/servicios' element = {<Servicios/>}/>
            <Route path='/testimonios' element = {<Testimonios/>}/>
        </Route>
    </Routes>
  )
}

export default Allroutes